import { render, staticRenderFns } from "./aliBeyEditor.vue?vue&type=template&id=47d1af0c&scoped=true"
import script from "./aliBeyEditor.vue?vue&type=script&lang=js"
export * from "./aliBeyEditor.vue?vue&type=script&lang=js"
import style0 from "./aliBeyEditor.vue?vue&type=style&index=0&id=47d1af0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d1af0c",
  null
  
)

export default component.exports